import { I18nSelector } from "../types";

export interface StationSectionTitle {
    id: string;
    title: I18nSelector;
}

export const editingStationSectionTitles: StationSectionTitle[] = [
    {
        id: 'address',
        title: i18n => i18n.sm.address.title,
    },
    {
        id: 'openingHours',
        title: i18n => i18n.sm.openingHours.title,
    },
    {
        id: 'managerDetails',
        title: i18n => i18n.sm.managerDetails.title,
    },
    {
        id: 'additionalDetails',
        title: i18n => i18n.sm.additionalDetails.title,
    },
];

export const openStationSectionTitles: StationSectionTitle[] = [
    {
        id: 'general',
        title: i18n => i18n.sp.generalTitle,
    },
    {
        id: 'ordersList',
        title: i18n => i18n.sp.table.list,
    },
    {
        id: 'address',
        title: i18n => i18n.sm.address.title,
    },
    {
        id: 'openingHours',
        title: i18n => i18n.sm.openingHours.title,
    },
    {
        id: 'managerDetails',
        title: i18n => i18n.sm.managerDetails.title,
    },
    {
        id: 'additionalDetails',
        title: i18n => i18n.sm.additionalDetails.title,
    },
    {
        id: 'freeSale',
        title: i18n => i18n.sideBar.sm.fs,
    },
];